export const zoom150Media = `only screen and (min-resolution: 192dpi),
  only screen and (min-resolution: 1.75dppx),
  only screen and (min--moz-device-pixel-ratio: 1.75),
  only screen and (-webkit-min-device-pixel-ratio: 1.75),
  only screen and (min-device-pixel-ratio: 1.75),
  only screen and (-webkit-zoom: 1.75) and (max-width: 800px)`;
